export const ADMIN_MERCHANT_SETTINGS_EDIT_ROUTE_NAME = Symbol('admin.merchant-settings.edit');

export const TRANSLATION_GROUP_MERCHANT_SETTINGS_EDIT = Symbol('admin.merchant-settings.edit');

export const GET_MERCHANT_SETTINGS_QUERY_KEY = 'merchant.get-merchant-settings';
export const EDIT_MERCHANT_SETTINGS_MUTATION = 'merchant.edit-merchant-settings';

export const MERCHANT_SETTINGS_API_URL = 'admin/merchants/:id';
